export default __webpack_public_path__ + "static/media/8_3.720502a0.jpg";